module.exports = __webpack_public_path__ + "img/twitter.0f0f2e83.svg";